export default __webpack_public_path__ + "static/icon-001a909a80b292fd5bc1d9cae2ac5b7b.png";